import React, { useRef, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import "./Bom.scss";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

import DeleteIcon from "@material-ui/icons/Delete";
import AddIcon from "@material-ui/icons/Add";
import EmailIcon from "@material-ui/icons/Email";
import PrintIcon from "@material-ui/icons/Print";
import SaveIcon from "@material-ui/icons/Save";

import SkuCard from "./SkuCard/SkuCard";
import { spec_sheet, downloadMappings } from "./SkuCard/SkuCard";

import ContactForm from "../ContactForm/ContactForm";
import EmailForm from "../EmailForm/EmailForm";

import ACTIONS from "../../actions/action";
import { connect } from "react-redux";
import { crossDomainPost } from "../../utils/iframe_form";

import _ from "lodash";

import {
  additional_options_readable,
  cri_readable,
  cct_readable,
  ceiling_type_readable,
  color_readable,
  controls_readable,
  downlight_output_2_readable,
  low_medium_high,
  mounting_options_readable,
  configurations_readable,
  voltage_readable
} from "./SkuCard/SkuCard";
import { Card } from "@material-ui/core";

var PrintTemplate = require("react-print");

const useStyles = makeStyles(theme => ({
  card: {
    padding: theme.spacing(3),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(3),
    textAlign: "center"
  },
  bomHeader: {
    marginRight: "auto"
  },
  leftIcon: {
    marginRight: theme.spacing(1)
  },
  rightIcon: {
    marginLeft: theme.spacing(1)
  },
  iconSmall: {
    fontSize: 20
  },
  contactModal: {
    textAlign: "left"
  },
  contactThanks: {
    textAlign: "center",
    paddingLeft: "5%",
    paddingRight: "5%"
  }
}));

// const handleClick = () =>
//         ref.current.scrollIntoView({
//           behavior: 'smooth',
//           block: 'start',
//         });

// const scrollToRef = (ref) => window.scrollTo(0, ref.current.offsetTop); 

const scrollToRef = (ref) => ref.current.scrollIntoView();
const useMountEffect = (param) => useEffect(param, []);

function Bom(props) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [openEmail, setOpenEmail] = React.useState(false);
  const [quoteCompleted, setQuoteCompleted] = React.useState(false);
  const [quoteInvalid, setQuoteInvalid] = React.useState(false);
  const [openNoQuote, setOpenNoQuote] = React.useState(false);

  let bomRef = React.createRef();

  useMountEffect(() => scrollToRef(bomRef)) // Scroll on mount

  const { billOfMaterials, configReset, clearPii, pii, localeSetting } = props;
  let newBom = _.cloneDeep(billOfMaterials);
  const bomRev = newBom.reverse();
  // const bomRev = billOfMaterials.reverse();

  //console.log(JSON.stringify(billOfMaterials));

  function modalOpen() {
    setOpen(true);
  }

  function noQuoteModalOpen() {
    setOpenNoQuote(true);
  }

  function emailModalOpen() {
    setOpenEmail(true);
  }

  function print() {
    window.print();
  }

  function modalClose() {
    clearPii();
    setOpen(false);
    setQuoteCompleted(false);
    setQuoteInvalid(false);
  }

  function noQuoteModalClose() {
    clearPii();
    setOpenNoQuote(false);
    setQuoteCompleted(false);
    setQuoteInvalid(false);
  }

  function emailModalClose() {
    clearPii();
    setOpenEmail(false);
    setQuoteCompleted(false);
    setQuoteInvalid(false);
  }
  

  function submitGetAQuote(noContact) {
    let contactData = _.cloneDeep(pii);

    if (
      contactData.privacy_policy !== "Yes" ||
      contactData.communication !== "Yes" ||
      !contactData.first_name ||
      !contactData.last_name ||
      !contactData.phone ||
      !contactData.city ||
      !contactData.state ||
      !contactData.company ||
      !contactData.email
    ) {
      setQuoteInvalid(true);
      return;
    }

    if(localeSetting.state == "Province" && !contactData.country){
      setQuoteInvalid(true);
      return;
    }

    contactData.bill_of_materials = bomToString();

    if(noContact){
      // debugger;
      // console.log("contactData:", contactData);
      if(contactData.country == "CA"){
        crossDomainPost(
          "https://www2.cree.com/l/64562/2020-10-21/f417pv",
          contactData
        );
      }else{
        crossDomainPost(
          "https://go.pardot.com/l/64562/2019-08-01/d3z88s",
          contactData
        );
      }
    }else{
      // debugger;
      // console.log("contactData:", contactData);
      if(contactData.country == "CA"){
        crossDomainPost(
          "https://www2.cree.com/l/64562/2020-10-20/f3zjnl",
          contactData
        ); 
      }else{
        crossDomainPost(
          "https://go.pardot.com/l/64562/2019-07-03/d31ydd",
          contactData
        );
      }
    }

    if(noContact){
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ 'event': 'formSubmission', 'formType': 'Contact Us SKU'});
    }else{
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ 'event': 'formSubmission', 'formType': 'Request a quote'});
    }
    

    //modalClose();
    setQuoteCompleted(true);
  }

  function submitEmail() {
    let contactData = _.cloneDeep(pii);

    if (
      contactData.privacy_policy !== "Yes" ||
      contactData.communication !== "Yes" ||
      !contactData.email
    ) {
      setQuoteInvalid(true);
      return;
    }

    contactData.bill_of_materials = bomToString();
    // contactData.spec = ""
    // contactData.spec_link = ""
    // contactData.ies = ""
    // contactData.ies_link = ""

    crossDomainPost(
      "https://go.pardot.com/l/64562/2019-07-08/d33rzv",
      contactData
    );

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ 'event': 'formSubmission', 'formType': 'Email BOM'});

    //modalClose();
    setQuoteCompleted(true);
  }

  function bomToString() {
    let fixedWith = 25;
    let str = "";
    
    billOfMaterials.forEach(row => {
      let productSKU = [
        "ST3",
        row.mountingOptions,
        row.length,
        row.uplightOutput,
        row.downlightOutput,
        row.cct,
        row.downlightOptic,
        row.controls,
        row.suspensionLength,
        row.ceilingType,
        row.color
      ];
    
      if(row.cri != "Blank")
        productSKU.splice(5, 0, row.cri);
    
        if(row.voltage != "Blank"){
          if(row.cri != "Blank"){
            productSKU.splice(7, 0, row.voltage);
          }else{
            productSKU.splice(6, 0, row.voltage);
          }
        }
    
      if(row.additionalOptions != "N")
        productSKU.push(row.additionalOptions);
        
      let sku = productSKU.filter(x => x).join("-");

      let documents = _.find(downloadMappings,{
        "Mounting": row.mountingOptions,
        "Uplight Level": row.uplightOutput?row.uplightOutput:"",
        "Downlight Level": row.downlightOutput,
        "Length": row["configurations"] == "Blank" ? parseInt(row.length) : 2
      });

      str += _.padEnd("SKU:", fixedWith) + ntb(sku) + "\n";
      str += _.padEnd("Quantity:", fixedWith) + ntb(row.quantity) + "\n";

      if(row.configurations != "C"){
        str += _.padEnd("Total Linear Feet:", fixedWith) + ntb(row.tlf) + "\n";
      }else{
        str += _.padEnd("Total Linear Feet:", fixedWith) + ntb("N/A") + "\n";
      }

      str += "\n";
      str +=
        _.padEnd("Mounting Options:", fixedWith) +
        ntb(mounting_options_readable[row.mountingOptions]) +
        "\n";


      str +=
        _.padEnd("Configuration:", fixedWith) +
        ntb(configurations_readable[row.configurations]) +
        "\n";

        if(row.configurations != "C"){
          if(Number.isInteger(parseInt(row.length))){
            str += _.padEnd("Length/Linear Feet:", fixedWith) + ntb(row.length) + "\n";
          } else{
            if(row.configurations != "S"){
              let dimensions = parseInt(row.sideA) + "'";
              if(parseInt(row.sideB) > 0){
                dimensions += "x" + parseInt(row.sideB) + "'";
              }
              if(parseInt(row.sideC) > 0){
                dimensions += "x" + parseInt(row.sideC) + "'";
              }
              str += _.padEnd("Length/Linear Feet:", fixedWith) + ntb(dimensions) +"\n";
            }else{
              str += _.padEnd("Length/Linear Feet:", fixedWith) + ntb(row.sideA) + "'x" + ntb(row.sideA) + "'" + "\n";
            }
          }
        }else{
          str += _.padEnd("Corners:", fixedWith) + ntb(row.sideA) + "\n";
        }
          
      
      str +=
        _.padEnd("Uplight Output:", fixedWith) +
        ntb(low_medium_high[row.uplightOutput]) +
        "\n";
      str +=
        _.padEnd("Downlight Output:", fixedWith) +
        ntb(low_medium_high[row.downlightOutput]) +
        "\n";

      str +=
        _.padEnd("CRI:", fixedWith) +
        ntb(cri_readable[row.cri]) +
        "\n";

      str +=
        _.padEnd("Correlated Color Temp:", fixedWith) +
        ntb(cct_readable[row.cct]) +
        "\n";
      str +=
        _.padEnd("Voltage:", fixedWith) +
        ntb(voltage_readable[row.voltage]) +
        "\n";
      str +=
        _.padEnd("Controls:", fixedWith) +
        ntb(controls_readable[row.controls]) +
        "\n";
      str +=
        _.padEnd("Suspension Length:", fixedWith) +
        ntb(row.suspensionLength) +
        "\n";
      str +=
        _.padEnd("Ceiling Type:", fixedWith) +
        ntb(ceiling_type_readable[row.ceilingType]) +
        "\n";
      str +=
        _.padEnd("Luminaire Color:", fixedWith) +
        ntb(color_readable[row.color]) +
        "\n";
      str +=
        _.padEnd("Additional Options:", fixedWith) +
        ntb(additional_options_readable[row.additionalOptions]) +
        "\n";
      str += "\n";
      str += _.padEnd("Spec Sheet:", fixedWith) + "\n" + _.padEnd(ntb(spec_sheet[row.mountingOptions]), fixedWith) + "\n\n";
      if(documents["Instruction File Link"]){
        str += _.padEnd("Instruction File:", fixedWith) + "\n" + _.padEnd(ntb(documents["Instruction File Link"]), fixedWith) + "\n\n"
      }
      if(document["Link"]){
        str += _.padEnd("IES Files:", fixedWith) + "\n" + _.padEnd(ntb(documents["Link"]), fixedWith) + "\n";
      }else{
        str += _.padEnd("IES Files:", fixedWith) + "\n";
        if(documents["Link1"])
          str += _.padEnd(ntb(documents["Link1"]), fixedWith) + "\n";

        if(documents["Link2"])
          str += _.padEnd(ntb(documents["Link2"]), fixedWith) + "\n";

        if(documents["Link3"])
          str += _.padEnd(ntb(documents["Link3"]), fixedWith) + "\n";

        str += "\n";
      }
      str += "-------------------------------------------------------";
      str += "\n";
    });

    console.log(str);

    return str;
  }

  function ntb(val) {
    return val ? val : "";
  }

  function configureAnotherProduct(event, value) {
    configReset();
  }

  return (
    <React.Fragment>
      <iframe
        title="misc tools frame"
        id="misc-frame"
        style={{ display: "none" }}
      />
      <div ref={bomRef} className="bom-wrapper">
        <Grid
          className="bom-header"
          container
          direction="row"
          alignItems="center"
        >
          <Grid item className={classes.bomHeader}>
            <Typography variant="h5">Bill of Materials</Typography>
          </Grid>
          {billOfMaterials.length > 0 && (
            <React.Fragment>
              <Grid className="no-print bom-actions-desktop" item>
                <Button
                  onClick={() => print()}
                  color="primary"
                  className={
                    classes.hidePrintButton + " bom-header-btn-secondary"
                  }
                >
                  <PrintIcon className={classes.leftIcon} />
                  Print
                </Button>
              </Grid>
              <Grid className="no-print bom-actions-desktop" item>
                <Button
                  onClick={emailModalOpen}
                  color="primary"
                  className="bom-header-btn-secondary"
                >
                  <EmailIcon className={classes.leftIcon} />
                  Email
                </Button>
              </Grid>
              <Grid className="no-print bom-actions-desktop" item>
                <Button
                  variant="contained"
                  color="default"
                  className="bom-header-btn-primary"
                  onClick={configureAnotherProduct}
                >
                  <AddIcon className={classes.leftIcon} />
                  Configure Another Product
                </Button>
              </Grid>
              <Grid className="no-print" item>
                <Button
                  onClick={modalOpen}
                  variant="contained"
                  color="secondary"
                  className="bom-header-btn-primary"
                >
                  {/* <Button variant="contained" color="secondary" className={classes.button}> */}
                  Get a Quote
                </Button>
              </Grid>
            </React.Fragment>
          )}
        </Grid>
        <hr />
        <div className="bom-list">
          {billOfMaterials.length > 0 ? (
            bomRev.map((row, index) => {
              return <SkuCard config={row} index={(billOfMaterials.length - 1) - index} {...props} />;
            })
          ) : (
            <div className={classes.card}>
              <Typography variant="h5" gutterBottom>
                There are currently no items in your Bill of Materials.
              </Typography>
              <Button
                onClick={configureAnotherProduct}
                variant="contained"
                color="secondary"
              >
                Configure a Product
              </Button>
            </div>
          )}
        </div>

        {billOfMaterials.length > 0 && (
          <span className="bom-actions-mobile">
            <Grid
              className="bom-header"
              container
              direction="row"
              alignItems="center"
            >
              <Grid className="no-print" item xs={12} sm={12}>
                <Button
                  onClick={modalOpen}
                  variant="contained"
                  color="secondary"
                  className="bom-header-btn-primary bom-header-btn-primary-raq"
                >
                  {/* <Button variant="contained" color="secondary" className={classes.button}> */}
                  Get a Quote
                </Button>
              </Grid>
              <Grid className="no-print" item xs={6} sm={3}>
                <Button
                  onClick={emailModalOpen}
                  color="primary"
                  className="bom-header-btn-secondary"
                >
                  <EmailIcon className={classes.leftIcon} />
                  Email
                </Button>
              </Grid>
              <Grid className="no-print" item xs={6} sm={3}>
                <Button
                  onClick={() => print()}
                  color="primary"
                  className="bom-header-btn-secondary"
                >
                  <PrintIcon className={classes.leftIcon} />
                  Print
                </Button>
              </Grid>
              <Grid className="no-print" item xs={12} sm={6}>
                <Button
                  variant="contained"
                  color="default"
                  className="bom-header-btn-primary"
                  onClick={configureAnotherProduct}
                >
                  <AddIcon className={classes.leftIcon} />
                  Configure Another Product
                </Button>
              </Grid>
            </Grid>
          </span>
        )}

        {billOfMaterials.length > 0 && (
          <div className="no-print raq-cta">
            <Typography variant="h6">
              Questions about this Bill of Materials? Contact a Cree Lighting
              representative for more information.
            </Typography>
            <Button
              onClick={noQuoteModalOpen}
              variant="contained"
              color="secondary"
              className={classes.button}
            >
              Contact Us
            </Button>
          </div>
        )}

        {/* Request a Quote Modal */}
        <Dialog
          open={open}
          onClose={modalClose}
          scroll="paper"
          maxWidth="md"
          className={classes.contactModal}
          aria-labelledby="Get a Quote"
        >
          <DialogTitle disableTypography>Request a Quote</DialogTitle>
          <DialogContent>
            {quoteCompleted && (
              <div className={classes.contactThanks}>
                <h2>Your information has been submitted.</h2>
                <p>
                  A confirmation of your quote request and a copy of your
                  product details has been sent to the email provided.
                </p>
              </div>
            )}

            {!quoteCompleted && <ContactForm {...props} />}
          </DialogContent>
          <DialogActions>
            {quoteInvalid && !quoteCompleted && (
              <p style={{ color: "red", margin: "0 30px 0 0" }}>
                Please check all required fields and try submitting again
              </p>
            )}

            {!quoteCompleted && (
              <React.Fragment>
                <Button onClick={modalClose} color="primary">
                  Cancel
                </Button>
                <Button
                  onClick={() => {
                    submitGetAQuote(false);
                  }}
                  variant="contained"
                  color="secondary"
                >
                  Submit
                </Button>
              </React.Fragment>
            )}

            {quoteCompleted && (
              <React.Fragment>
                <Button onClick={modalClose} color="primary">
                  Close
                </Button>
              </React.Fragment>
            )}
          </DialogActions>
        </Dialog>

        {/* No Quote Modal */}
        <Dialog
          open={openNoQuote}
          onClose={noQuoteModalClose}
          scroll="paper"
          maxWidth="md"
          className={classes.contactModal}
          aria-labelledby="Get a Quote"
        >
          <DialogTitle disableTypography>Contact Us</DialogTitle>
          <DialogContent>
            {quoteCompleted && (
              <div className={classes.contactThanks}>
                <h2>Your information has been submitted.</h2>
                <p>
                  Thank you for your interest in the Styllus Linear™ Series. A
                  Cree Lighting representative will review your request and get
                  back to soon.{" "}
                </p>
              </div>
            )}

            {!quoteCompleted && <ContactForm noquote={true} {...props} />}
          </DialogContent>
          <DialogActions>
            {quoteInvalid && !quoteCompleted && (
              <p style={{ color: "red", margin: "0 30px 0 0" }}>
                Please check all required fields and try submitting again.
              </p>
            )}

            {!quoteCompleted && (
              <React.Fragment>
                <Button onClick={noQuoteModalClose} color="primary">
                  Cancel
                </Button>
                <Button
                  onClick={() => {
                    submitGetAQuote(true);
                  }}
                  variant="contained"
                  color="secondary"
                >
                  Submit
                </Button>
              </React.Fragment>
            )}

            {quoteCompleted && (
              <React.Fragment>
                <Button onClick={noQuoteModalClose} color="primary">
                  Close
                </Button>
              </React.Fragment>
            )}
          </DialogActions>
        </Dialog>

        {/* Email BOM Modal */}
        <Dialog
          open={openEmail}
          onClose={emailModalClose}
          scroll="paper"
          maxWidth="sm"
          className={classes.contactModal}
          aria-labelledby="Email Bill of Materials"
        >
          <DialogTitle disableTypography>Email Bill of Materials</DialogTitle>
          <DialogContent>
            {quoteCompleted && (
              <div className={classes.contactThanks}>
                <h2>Thank you!</h2>
                <p>
                  A copy of your bill of materials has been sent to the email
                  provided.
                </p>
                <hr />
                <p>
                  <em>
                    Would you like to contact a Cree Lighting customer service
                    representative?
                  </em>
                </p>
                <Button
                  onClick={() => {
                    emailModalClose();
                    modalOpen();
                  }}
                  variant="contained"
                  color="secondary"
                  className="bom-header-btn-primary bom-header-btn-primary-raq"
                >
                  {/* <Button variant="contained" color="secondary" className={classes.button}> */}
                  Get a Quote
                </Button>
              </div>
            )}

            {!quoteCompleted && <EmailForm {...props} />}
          </DialogContent>
          <DialogActions>
            {quoteInvalid && !quoteCompleted && (
              <p style={{ color: "red", margin: "0 30px 0 0" }}>
                Please check all required fields and try submitting again.
              </p>
            )}

            {!quoteCompleted && (
              <React.Fragment>
                <Button onClick={emailModalClose} color="primary">
                  Cancel
                </Button>
                <Button
                  onClick={submitEmail}
                  variant="contained"
                  color="secondary"
                >
                  Submit
                </Button>
              </React.Fragment>
            )}

            {quoteCompleted && (
              <React.Fragment>
                <Button onClick={emailModalClose} color="primary">
                  Close
                </Button>
              </React.Fragment>
            )}
          </DialogActions>
        </Dialog>
      </div>
    </React.Fragment>
  );
}

const mapStateToProps = state => ({
  billOfMaterials: state.billOfMaterials,
  currentView: state.currentView,
  pii: state.pii,
  localeSetting: state.localeSettings
});

const mapDispatchToProps = dispatch => ({
  createItem: item => dispatch(ACTIONS.setConfigItem(item)),
  deleteConfig: item => dispatch(ACTIONS.deleteConfig(item)),
  configReset: () => dispatch(ACTIONS.configReset()),
  editBom: item => dispatch(ACTIONS.editBom(item)),
  setQuoteItem: item => dispatch(ACTIONS.setQuoteItem(item)),
  clearPii: () => dispatch(ACTIONS.clearPii())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Bom);
